export default __webpack_public_path__ + "static/media/ticket57-10.426b7132.png";